module.exports = __webpack_public_path__ + "img/msg_bg.56e7d58d.svg";